/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum CompanyDocumentStatus {
  VALIDATION_PENDING = 'VALIDATION_PENDING',
  VALID = 'VALID',
  INVALID = 'INVALID',
}
